module.exports = __webpack_public_path__ + "static/Planetly-74b1b9b9a7482ebbbd65de05333374d8.jpg";